import type { SVGProps } from "react";

export default function DashboardIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.08252 5.41683C2.08252 3.57588 3.5749 2.0835 5.41585 2.0835C7.2568 2.0835 8.74919 3.57588 8.74919 5.41683C8.74919 7.25778 7.2568 8.75016 5.41585 8.75016C3.5749 8.75016 2.08252 7.25778 2.08252 5.41683Z"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
      <path
        d="M11.249 14.5828C11.249 12.7419 12.7414 11.2495 14.5824 11.2495C16.4233 11.2495 17.9157 12.7419 17.9157 14.5828C17.9157 16.4238 16.4233 17.9162 14.5824 17.9162C12.7414 17.9162 11.249 16.4238 11.249 14.5828Z"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
      <path
        d="M17.9157 5.41683C17.9157 3.84548 17.9157 3.0598 17.4275 2.57165C16.9394 2.0835 16.1537 2.0835 14.5824 2.0835C13.011 2.0835 12.2254 2.0835 11.7372 2.57165C11.249 3.0598 11.249 3.84548 11.249 5.41683C11.249 6.98818 11.249 7.77385 11.7372 8.262C12.2254 8.75016 13.011 8.75016 14.5824 8.75016C16.1537 8.75016 16.9394 8.75016 17.4275 8.262C17.9157 7.77385 17.9157 6.98818 17.9157 5.41683Z"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
      <path
        d="M8.74919 14.5828C8.74919 13.0115 8.74919 12.2258 8.26103 11.7377C7.77288 11.2495 6.9872 11.2495 5.41585 11.2495C3.8445 11.2495 3.05883 11.2495 2.57068 11.7377C2.08252 12.2258 2.08252 13.0115 2.08252 14.5828C2.08252 16.1542 2.08252 16.9398 2.57068 17.428C3.05883 17.9162 3.8445 17.9162 5.41585 17.9162C6.9872 17.9162 7.77288 17.9162 8.26103 17.428C8.74919 16.9398 8.74919 16.1542 8.74919 14.5828Z"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
    </svg>
  );
}
